import { LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { AnalysisSectionLabels } from '../../../edrIncidentDetails/types';
import { styles } from '../view/styles';
import { FontSizes, FontWeights } from '../../../../types/common/types';

/**
 * @summary Type here the description of this component
 * @tag incident-details-analysis-section
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement('incident-details-analysis-section')
export class IncidentDetailsAnalysisSectionWebComponent extends LitElement {
  @property({ attribute: false })
  status = '';

  @property({ attribute: false })
  assignee = '';

  @property({ attribute: false })
  priority = '';

  @property({ attribute: false })
  translations: AnalysisSectionLabels;

  static get styles() {
    return styles;
  }

  render() {
    return html`
      <gz-title
        fontSize="${FontSizes.PARAGRAPH_11}"
        fontWeight="${FontWeights.SEMIBOLD}"
        class="section-title mb-2 text-uppercase"
        >${this.translations.sectionTitle}</gz-title
      >

      <gz-labeled-content label="${this.translations.status}"
        ><gz-tooltip isEllipsis tooltiptext="${this.status}">${this.status}</gz-tooltip></gz-labeled-content
      >
      <gz-labeled-content label="${this.translations.assignee}"
        ><gz-tooltip isEllipsis tooltiptext="${this.assignee}">${this.assignee}</gz-tooltip></gz-labeled-content
      >
      <gz-labeled-content label="${this.translations.priority}"
        ><gz-tooltip isEllipsis tooltiptext="${this.priority}">${this.priority}</gz-tooltip></gz-labeled-content
      >
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'incident-details-analysis-section': IncidentDetailsAnalysisSectionWebComponent;
  }
}
